import { Card, Descriptions } from 'antd';
import React, { memo } from 'react';

/**
 * Component for displaying applicant academic information related to the current application
 * @param {Object} props - Component props
 * @param {Object} props.data - Applicant data object
 */
const AcademicInfo = memo(({ data }) => {
    if (!data) return null;

    return (
        
        <Card className="mb-4" title="Enrollment Information (Current Application)">
            <Descriptions 
                bordered 
                column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }} 
                size="small"
            >
                <Descriptions.Item label="Academic Level (Applying for)">{data.academicLevel || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Academic Strand (Applying for)">{data.academicStrand || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Academic Year (Applying for)">{data.academicYear || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Academic Term (Applying for)">{data.academicTerm || 'N/A'}</Descriptions.Item>
                <Descriptions.Item label="Applicant ID">{data.applicantID || 'N/A'}</Descriptions.Item>
            </Descriptions>
        </Card>
    );
});

export default AcademicInfo;